/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IState } from '../store/types/StateTypes';

import apiReducer from './apiReducer';
import metadataReducer from './metadataReducer';
import genericVisualizationReducer from './genericVisualizationReducer';
import { multiLevelDataReducer } from './multiLevelDataReducer';
import visualizationChooserReducer from './visualizationChooserReducers';
import titleComponentReducer from './titleComponentReducers';
import { multiAxisDataReducer } from './multiAxisDataReducer';
import {
    IMetadataReducerActionData,
    IMultiLevelReducerActionData,
    IReducerAction,
    IReducerActionData,
    IVisualizationReducerActionData
} from '../store/types/ReducerTypes';

import initialState from '../store/initialState';

export default (state: IState = initialState(), action: IReducerAction<IReducerActionData>) => {

    let newState = apiReducer(state, action as IReducerAction<IMetadataReducerActionData>);
    newState = metadataReducer(newState, action as IReducerAction<IMetadataReducerActionData>);
    newState = multiLevelDataReducer(newState, action as IReducerAction<IMultiLevelReducerActionData>);
    newState = multiAxisDataReducer(newState, action);
    newState = visualizationChooserReducer(newState, action);
    newState = titleComponentReducer(newState, action);
    newState = genericVisualizationReducer(newState, action as IReducerAction<IVisualizationReducerActionData>);

    return newState;
};
